<button
  *ngIf="showAddButton"
  class="floatFab"
  mat-fab
  color="primary"
  [matTooltip]="addButtonTooltip"
  (click)="addItem()"
>
  <mat-icon>add</mat-icon>
</button>
<div *ngIf="dataSource && displayedColumns; else empty">
  <div class="summaries" *ngIf="additionalInfo && data && data.additionalInfo">
    <mat-card appearance="outlined" *ngFor="let info of additionalInfo">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon>{{ info.icon }}</mat-icon>
        </div>
        <mat-card-title>{{ info.title }}</mat-card-title>
        <mat-card-subtitle>{{
          data.additionalInfo[info.name]
        }}</mat-card-subtitle>
      </mat-card-header>
    </mat-card>
  </div>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="announceSortChange($event)"
    class="mat-elevation-z8"
  >
    <ng-container
      *ngFor="let col of colDefinitions; let i = index"
      [matColumnDef]="col.name"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        (contextmenu)="onContextMenu($event, col)"
        (mousemove)="colorMove($event, i)"
        (mouseleave)="colorLeave(i)"
        (mousedown)="onResizeColumn($event, i)"
      >
        <span
          mat-sort-header
          [matBadge]="isFiltered(col.name) ? 'filter_alt' : ''"
          matBadgeColor="accent"
          matBadgePosition="below"
          sortActionDescription="Sort by {{ col.name }}"
          >{{ col.title }}</span
        >
      </th>
      <td mat-cell *matCellDef="let element">
        <div
          *ngIf="col.action; else normal"
          (click)="col.action(element[col.name])"
          class="primary-text"
          style="cursor: pointer"
        >
          {{
            col.isDate ? (element[col.name] | date: 'short') : element[col.name]
          }}
        </div>
        <ng-template #normal>
          {{
            col.isDate ? (element[col.name] | date: 'short') : element[col.name]
          }}
        </ng-template>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-toolbar>
    <mat-toolbar-row>
      <mat-paginator
        *ngIf="data && data.total > 50"
        [pageSizeOptions]="[50, 100, 1000, 5000]"
        (page)="paging($event)"
        [length]="data.total"
        [pageSize]="count"
        [pageIndex]="page"
        showFirstLastButtons
        aria-label="Select page of client shipping rows"
      ></mat-paginator>
      <button
        color="accent"
        *ngIf="data && showExport"
        mat-mini-fab
        [matMenuTriggerFor]="export"
      >
        <mat-icon fontSet="material-symbols-outlined">export_notes</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="tableFooter"></div>
  <div class="update" *pcpHeaderInject="headerItemLocation.end">
    <mat-spinner
      class="contrast-spinner"
      [diameter]="20"
      *ngIf="updating"
    ></mat-spinner>
  </div>
</div>
<ng-template #empty>
  <span *ngIf="!fontSet" class="empty mat-headline-1">
    <mat-icon [inline]="true">{{ icon }}</mat-icon>
  </span>
  <span *ngIf="fontSet" class="empty mat-headline-1">
    <mat-icon [fontSet]="fontSet" [inline]="true">{{ icon }}</mat-icon>
  </span>
</ng-template>
<ng-container *ngIf="showGoBack">
  <button
    mat-icon-button
    *pcpHeaderInject="headerItemLocation.start"
    (click)="goBack()"
  >
    <mat-icon class="mat-icon-rtl-mirror">arrow_back</mat-icon>
  </button>
</ng-container>
<div
  #filterMenu
  style="visibility: hidden; position: fixed"
  [style.left]="contextMenuPosition.x"
  [style.top]="contextMenuPosition.y"
  [matMenuTriggerFor]="contextMenu"
></div>
<mat-menu #export="matMenu">
  <button mat-menu-item (click)="exportPage()">
    <mat-icon>download</mat-icon>
    <span i18n>Export current page</span>
  </button>
  <button mat-menu-item (click)="exportAll()">
    <mat-icon fontSet="material-symbols-outlined">chrome_tote</mat-icon>
    <span i18n>Export all pages</span>
  </button>
</mat-menu>
<mat-menu #contextMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="filter(item)">
      <mat-icon>filter_alt</mat-icon>
      <span i18n>Filter</span>
    </button>
    <button
      mat-menu-item
      *ngIf="isFiltered(item.name)"
      (click)="clearFilter(item)"
    >
      <mat-icon>filter_alt_off</mat-icon>
      <span i18n>Cancel filter</span>
    </button>
  </ng-template>
</mat-menu>
